import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const Letter = ({ letter, selectLetter, selected, enabled }) => {
  const handleClick = () => {
    selectLetter(letter);
  };
  const letterClass = classNames('c-letters__letter', {
    'is-selected': selected,
  });

  return (
    <li>
      <button
        type="button"
        className={letterClass}
        onClick={handleClick}
        disabled={!enabled}
      >
        { letter }
      </button>
    </li>
  );
};

Letter.propTypes = {
  selectLetter: PropTypes.func.isRequired,
  letter: PropTypes.string,
  selected: PropTypes.bool,
  enabled: PropTypes.bool,
};

export default Letter;
